module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Oops!")]), _vm._v(" "), _c('p', [_vm._v("\n      There was a problem with your rmCloud license.  Please try installing the add-on again or asking your adminstrator.\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-071b192f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MissingLicense.vue
// module id = 993
// module chunks = 1